import { render, staticRenderFns } from "./ResearcherClaim.vue?vue&type=template&id=bf1ebb74&scoped=true&"
import script from "./ResearcherClaim.vue?vue&type=script&lang=js&"
export * from "./ResearcherClaim.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherClaim.vue?vue&type=style&index=0&id=bf1ebb74&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1ebb74",
  null
  
)

export default component.exports